import PlanOverview from '@/components/supplier/dashboard/plan-overview';
import { getSubscriptionOverview } from '@/services';
import { getStatisticsOpportunities } from '@/services/api/statistics';
import Extract from '@/components/supplier/dashboard/extract';
import ExtractModal from '@/components/supplier/dashboard/extract/extract-modal.vue';
import { configAxiosExtract } from '@/utils/api-instance';

export default {
    name: 'DashboardSupplier',
    components: {
        PlanOverview,
        Extract,
        ExtractModal
    },
    data: () => ({
        subscription: {
            supplier: {},
            plan: {}
        },
        statisticsOpportunities: {},
        loaderPlanOverview: false,
        isMobile: false,
        extractList: [],
        extractListLoading: false,
        extractModal: false
    }),
    async created() {
        await this.initializeData();
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;

        this.fetchExtracts();
    },
    methods: {
        async initializeData() {
            this.loaderPlanOverview = true;
            this.subscription = await this.getSubscriptionOverview();
            await this.filterChange(15);
            this.loaderPlanOverview = false;
        },
        async filterChange(daysAgo) {
            return (this.statisticsOpportunities = await this.getStatisticsOpportunities(daysAgo));
        },
        async getSubscriptionOverview() {
            const data = await getSubscriptionOverview();
            return data;
        },
        async getStatisticsOpportunities(daysAgo) {
            const { data } = await getStatisticsOpportunities(daysAgo);
            return data;
        },
        async fetchExtracts() {
            this.extractListLoading = true;
            try {
                const { data } = await configAxiosExtract().get();
                this.extractList = data.results;
            } catch (error) {
                console.error(error);
            } finally {
                this.extractListLoading = false;
            }
        },
        openModalExtract() {
            this.extractModal = true;
        },
        closeModalExtract() {
            this.extractModal = false;
        }
    }
};
